import { legacyRedirect } from './-components';
import { createFileRoute } from '@tanstack/react-router';

// The old `journeys` URL for the Customer.io connector, which the integrations directory and the
// activity-log empty state (`?fragment=snippet`, carried across) still link to. The page lives at
// `/workspaces/:workspaceId/integrations/customerio`.
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/customerio')({
  beforeLoad: legacyRedirect('/workspaces/:workspaceId/integrations/customerio'),
});
